import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
// import { Observable } from 'rxjs';
// Ancien import du tuto qui ne marche plus
// import * as firebase from 'firebase';
// !! Du coup ne pas oublier d'impoter les autres modules comme auth et firestore!!
import firebase from 'firebase/app';
import 'firebase/auth';
// import "firebase/firestore";

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate {

  constructor(private router: Router) { }

  // Je sais pas pourquoi il définit tous ces retours possibles si il écrit en dur que ça return une Promise
  // canActivate(): Observable<boolean> | Promise<boolean> | boolean {

  canActivate(): Promise<boolean> {
    return new Promise(
      (resolve, reject) => {
        firebase.auth().onAuthStateChanged(
          (user) => {
            if (user) {
              resolve(true);
            } else {
              // Pour le chemin de navigate, on sépare les dossiers par les virgules
              this.router.navigate(['/auth', 'signin']);
              resolve(false)
            }
          }
        )
      }
    )
  }
}
